module.exports = __webpack_public_path__ + "img/category-Adventure.9cec236e.svg";